import { render, staticRenderFns } from "./ForumLeft.vue?vue&type=template&id=ff814924&scoped=true"
import script from "./ForumLeft.vue?vue&type=script&lang=js"
export * from "./ForumLeft.vue?vue&type=script&lang=js"
import style0 from "./ForumLeft.vue?vue&type=style&index=0&id=ff814924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff814924",
  null
  
)

export default component.exports